import React, {useCallback} from 'react'
import {graphql} from 'gatsby'
import './Hero.scss'
import video from '../../assets/video/hero.mp4'
import Button from '../Button/Button'

export default function Hero({text, title, button, buttonText}) {

	const videoContainer = useCallback(node => {
		if(node !== null) {
			setTimeout(() => {
				node.play()
			}, 1000)
		}
	},[])

	return (
		<div className="Hero">
			<div className="left">
				<div className="inner">
					{ title ? <h1 dangerouslySetInnerHTML={{__html: title}} /> : null }
					{ text ? <p dangerouslySetInnerHTML={{__html: text}} /> : null }
					{
						button &&
						<>
							<Button id="hero_prov_gratis" url={button.url} title={button.title} color="primary" />
							{
								buttonText &&
								<p className="button-text" aria-labelledby="hero_prov_gratis">{buttonText}</p>
							}
						</>
					}
				</div>
			</div>
			<div className="right">
				<div className="video">
					<video muted playsInline ref={videoContainer} aria-label="Illustrasjonsvideo av Lovdata Pro funksjoner">
						<source src={video} type="video/mp4" />
					</video>
				</div>
			</div>
		</div>
	)
}

export const query = graphql`
	fragment Hero on WpPage_Layout_block_Layout_Hero {
		fieldGroupName
		button {
			target
			title
			url
		}
		buttonText
		title
		text
	}
`